import type { EnumLapType } from "./generated/graphql";

export const isLapTypeGreen = {
  ATTACK: true,
  COOL: true,
  IN: true,
  OUT: true,
  OUTIN: true,
  PREP: true,
  PUSH: true,
  QUALI: true,
  SHAKEDOWN: true,
  SLOW: true,
  TARGET: true,
  FCY: false,
  SAFETYCAR: false,
  UNFINISHED: false,
  TOGRID: false,
  TOPADDOCK: false,
  TOPITS: false,
  PITLANE: false,
} satisfies Record<EnumLapType, boolean>;

export const isValidFastestLapType = {
  ATTACK: true,
  COOL: true,
  IN: false,
  OUT: false,
  OUTIN: false,
  PREP: true,
  PUSH: true,
  QUALI: true,
  SHAKEDOWN: true,
  SLOW: true,
  TARGET: true,
  FCY: false,
  SAFETYCAR: false,
  UNFINISHED: false,
  TOGRID: false,
  TOPADDOCK: false,
  TOPITS: false,
  PITLANE: false,
} satisfies Record<EnumLapType, boolean>;
